function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
import moment from 'moment';
import { localPaginationMixin } from '@/mixins/local_pagination';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
export default {
  name: 'ViewAttributeGroupComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    enable_actions: {
      type: Boolean,
      required: false,
      default: false
    },
    edit_attributes: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    enable_edit_sandbox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      label: {
        group_name: this.translate('attributes.label.group_name'),
        group_date: this.translate('attributes.label.group_date'),
        group_description: this.translate('attributes.label.group_description')
      },
      form: {
        group_name: null,
        group_date: null,
        group_description: null
      },
      isLoading: false,
      attributes: [],
      partitionsByTable: {},
      valid: true,
      filtro: {
        category_comma: '',
        q: ''
      }
    };
  },
  beforeMount: function beforeMount() {
    this.getAttributes();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    addToEditSandbox: function addToEditSandbox(item, add) {
      this.$emit("onSelectAttr", item, add);
    },
    addAllGroup: function addAllGroup() {
      this.$emit("addAllGroup", this.attributes, true);
    },
    verifySelected: function verifySelected(item) {
      var items = this.edit_attributes.filter(function (x) {
        return x.dataset == item.dataset && x.tabla == item.tabla && x.nombre == item.nombre;
      });
      return items.length > 0;
    },
    getAttributes: function getAttributes() {
      var _this = this;
      this.setShowLoading(true);
      var listaAdicional = [];
      UseCasesService.getAttributesGroupsFields(this.companyCode, this.item.id).then(function (response) {
        _this.form.group_name = response.data.metadata[0].preference_group_name;
        _this.form.group_description = response.data.metadata[0].group_description;
        _this.form.group_date = moment(String(response.data.metadata[0].creation_date)).format('DD/MM/YYYY hh:mm:ss a');
        _this.attributes = Object.values(response.data.attributes).map(function (item) {
          _this.filtro.category_comma = item.attribute_category;
          _this.filtro.q = item.attribute_name;
          var aditional = search_engine_service.getBuscadorAtributosEspecifico(_this.filtro);
          listaAdicional.push(aditional);
          return {
            nombre: item.attribute_name,
            categoria: item.attribute_category,
            descripcion: '-',
            tipo_dato: '-',
            no_nulo: ''
          };
        });
      }).catch(function (err) {
        tasks.toast.error(_this.translate('error_messages.error_general'), _this.translate('titles.error'));
      }).finally(function () {
        _this.setShowLoading(false);
        Promise.all(listaAdicional).then(function (values) {
          values.forEach(function (value) {
            _this.editedIndex = _this.attributes.findIndex(function (item) {
              return item.categoria == value.busqueda[0].categoria && item.nombre == value.busqueda[0].nombre;
            });
            if (_this.editedIndex >= 0) {
              _this.editedItem = Object.assign({}, value.busqueda[0]);
              Object.assign(_this.attributes[_this.editedIndex], _this.editedItem);
            }
          });
        });
      });
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    headers: function headers() {
      var h = [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre'
      }, {
        text: this.translate('attributes.search.table_search_list.description'),
        value: 'descripcion'
      }, {
        text: this.translate('attributes.search.table_search_list.category'),
        value: 'categoria'
      }, {
        text: this.translate('attributes.search.table_search_list.data_type'),
        value: 'tipo_dato'
      }, {
        text: this.translate('attributes.search.table_search_list.percentage'),
        value: 'no_nulo'
      }];
      if (this.enable_actions) {
        h.push({
          text: this.translate('attributes.search.table_search_list.actions.title'),
          value: 'actions',
          sortable: false
        });
      }
      return h;
    }
  })
};